package pl.decks.personal.pages.ievp

sealed interface IEVPPageEvent {
    data class SectionClicked(val section: IEVPSection) : IEVPPageEvent
    data object ScrollToSectionConsumed : IEVPPageEvent
    data class SectionMeasuresChanged(
        val section: IEVPSection,
        val measures: IEVPPageState.SectionMeasures,
    ) : IEVPPageEvent
    data class SectionReached(val section: IEVPSection) : IEVPPageEvent
}
